import { supabase } from '../lib/supabase'
import type { WikiDepartment, WikiUserDepartment, WikiGroupDepartment } from '../types/wiki'

// =============================
// User ↔ Department access
// =============================

export async function getUserDepartments(userId: string): Promise<WikiDepartment[]> {
  const { data, error } = await supabase
    .from('wiki_user_departments')
    .select('department:wiki_departments(*)')
    .eq('user_id', userId)

  if (error) throw error
  return (data || [])
    .map((row: any) => row.department)
    .filter(Boolean) as WikiDepartment[]
}

export async function grantUserDepartment(userId: string, departmentId: string): Promise<void> {
  const payload: WikiUserDepartment = {
    user_id: userId,
    department_id: departmentId,
    created_at: new Date().toISOString()
  }

  const { error } = await supabase
    .from('wiki_user_departments')
    .upsert(payload, { onConflict: 'user_id,department_id' })

  if (error) throw error
}

export async function revokeUserDepartment(userId: string, departmentId: string): Promise<void> {
  const { error } = await supabase
    .from('wiki_user_departments')
    .delete()
    .eq('user_id', userId)
    .eq('department_id', departmentId)

  if (error) throw error
}

// =============================
// Group ↔ Department access
// =============================

export async function getGroupDepartments(groupId: string): Promise<WikiDepartment[]> {
  const { data, error } = await supabase
    .from('wiki_group_departments')
    .select('department:wiki_departments(*)')
    .eq('user_group_id', groupId)

  if (error) throw error
  return (data || [])
    .map((row: any) => row.department)
    .filter(Boolean) as WikiDepartment[]
}

export async function grantGroupDepartment(groupId: string, departmentId: string): Promise<void> {
  const payload: WikiGroupDepartment = {
    user_group_id: groupId,
    department_id: departmentId,
    created_at: new Date().toISOString()
  }

  const { error } = await supabase
    .from('wiki_group_departments')
    .upsert(payload, { onConflict: 'user_group_id,department_id' })

  if (error) throw error
}

export async function revokeGroupDepartment(groupId: string, departmentId: string): Promise<void> {
  const { error } = await supabase
    .from('wiki_group_departments')
    .delete()
    .eq('user_group_id', groupId)
    .eq('department_id', departmentId)

  if (error) throw error
}


